import type { ReactNode } from 'react';
import { EmptyState } from './EmptyState';
import { Button } from './Button';

export interface ErrorStateProps {
  title?: string;
  message?: ReactNode;
  onRetry?: () => void;
}

export function ErrorState({
  title = 'Щось пішло не так',
  message = 'Спробуй пізніше — або напиши, що шукаєш.',
  onRetry,
}: ErrorStateProps): JSX.Element {
  return (
    <EmptyState
      icon="sad"
      title={title}
      message={message}
      actions={
        onRetry ? (
          <Button variant="secondary" onClick={onRetry}>
            Спробувати знову
          </Button>
        ) : null
      }
    />
  );
}
